export default "__VITE_ASSET__Bc1oeTbc__"